var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrizeObjectBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    viewBox: "0 0 232 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 231,
    height: 231,
    rx: 115.5,
    fill: "url(#paint0_linear_939_4569)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 231,
    height: 231,
    rx: 115.5,
    stroke: "url(#paint1_linear_939_4569)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_939_4569",
    x1: 116,
    y1: 0,
    x2: 116,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5B45F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_939_4569",
    x1: 116,
    y1: 0,
    x2: 116,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E5B45F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrizeObjectBackground);
export default __webpack_public_path__ + "static/media/prize-object-background.ff2d1dafab2196ebbb02308ea19a2cfa.svg";
export { ForwardRef as ReactComponent };